export default ({ app }, inject) => {
  const direction = () =>
    app.i18n.locales.find((x) => x.code === app.i18n.locale)?.dir
  inject('direction', direction)
}
